export enum EMasterMechanicURLParams {
  SUPPLIER_ID = 'Supplier_id',
}
